<template lang="pug">
.user-history(@mousedown="startCounter" @mouseup="restartCounter" @mouseleave="restartCounter" @touchstart="startCounter" @touchend.prevent="restartCounter" :class="{'no-select': !select}") {{ actorLabel }}
  span(v-if="interval && !(name || nameStore)")  ({{ seconds - secondsPressed + 1 }}s)
</template>

<script>
import gql from '@my/graphql'
import gqlUser from '@/graphql/user'
import mHoldDown from '@/mixins/holdDown'
import mFilters from '@/mixins/filters'

export default {
  name: 'NameUser',

  mixins: [mHoldDown, mFilters],

  props: {
    dni: '',
    select: { type: Boolean, default: false }
  },

  data () {
    return {
      seconds: 1,
      name: ''
    }
  },

  methods: {
    async onCounterFinish () {
      if (!this.nameStore) {
        const query = gqlUser.GET_NAME

        const response = await gql.query(query, { dni: this.dni })

        if (response && response.data.getNameUser) {
          this.name = response.data.getNameUser.name
          this.$store.commit('setName', { dni: this.dni, name: this.name })
        }
      }
    }
  },

  computed: {
    nameStore () {
      return this.$store.state.listNames[this.dni]
    },

    actorLabel () {
      if (this.dni === 'system') return 'system'
      if (this.dni === 'mcp-bot') return 'MCP'
      if (this.dni === 'user') return this.capitalize('cliente')
      if (this.nameStore || this.name) return this.capitalize(this.nameStore || this.name)
      if (this.dni) return `...${this.dni.slice(-3)}`
      return ''
    }
  }
}
</script>

<style lang="stylus">
@import '~@/stylus/functions.styl'

.user-history.no-select
  noSelect()
</style>



// WEBPACK FOOTER //
// src/components/elements/NameUser.vue